export const TOGGLE_LOADING = 'staff/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'staff/TOGGLE_SUCCESS'
export const TOGGLE_ERROR = 'staff/TOGGLE_ERROR'
export const SET_STAFF_PROJECT = 'staff/SET_STAFF_PROJECT'
export const ADD_OPENED_CHILD_ID = 'staff/ADD_OPENED_CHILD_ID'
export const REMOVE_OPENED_CHILD_ID = 'staff/REMOVE_OPENED_CHILD_ID'
export const SET_STAFF_XML = 'staff/SET_STAFF_XML'

export const SET_STATUS = 'staff/SET_STATUS'

export const GET_POSITION_DEPT_TYPE = 'staff/GET_POSITION_DEPT_TYPE'
export const GET_POSITION_DEPT_TYPE_DONE = 'staff/GET_POSITION_DEPT_TYPE_DONE'
export const GET_POSITION_DEPT_TYPE_FAIL = 'staff/GET_POSITION_DEPT_TYPE_FAIL'

export const GET_POSITION_ESTABLISHED_POST = 'staff/GET_POSITION_ESTABLISHED_POST'
export const GET_POSITION_ESTABLISHED_POST_DONE = 'staff/GET_POSITION_ESTABLISHED_POST_DONE'
export const GET_POSITION_ESTABLISHED_POST_FAIL = 'staff/GET_POSITION_ESTABLISHED_POST_FAIL'


export const GET_STAFF_EXPERIENCE = 'staff/GET_STAFF_EXPERIENCE'
export const GET_STAFF_EXPERIENCE_DONE = 'staff/GET_STAFF_EXPERIENCE_DONE'
export const GET_STAFF_EXPERIENCE_FAIL = 'staff/GET_STAFF_EXPERIENCE_FAIL'

export const GET_STAFF_UNIT = 'staff/GET_STAFF_UNIT'
export const GET_STAFF_UNIT_DONE = 'staff/GET_STAFF_UNIT_DONE'
export const GET_STAFF_UNIT_FAIL = 'staff/GET_STAFF_UNIT_FAIL'

export const GET_STAFF_LEVEL = 'staff/GET_STAFF_LEVEL'
export const GET_STAFF_LEVEL_DONE = 'staff/GET_STAFF_LEVEL_DONE'
export const GET_STAFF_LEVEL_FAIL = 'staff/GET_STAFF_LEVEL_FAIL'

export const GET_STAFF_CATEGORY = 'staff/GET_STAFF_CATEGORY'
export const GET_STAFF_CATEGORY_DONE = 'staff/GET_STAFF_CATEGORY_DONE'
export const GET_STAFF_CATEGORY_FAIL = 'staff/GET_STAFF_CATEGORY_FAIL'

export const SAVE_ALLOW_STAFF_CIVIL = 'staff/SAVE_ALLOW_STAFF_CIVIL'
export const SAVE_ALLOW_STAFF_CIVIL_DONE = 'staff/SAVE_ALLOW_STAFF_CIVIL_DONE'
export const SAVE_ALLOW_STAFF_CIVIL_FAIL = 'staff/SAVE_ALLOW_STAFF_CIVIL_FAIL'

export const GET_ESTABLISHED_POST_BY_CATEGORY_CODE = 'staff/GET_ESTABLISHED_POST_BY_CATEGORY_CODE'
export const GET_ESTABLISHED_POST_BY_CATEGORY_CODE_DONE = 'staff/GET_ESTABLISHED_POST_BY_CATEGORY_CODE_DONE'
export const GET_ESTABLISHED_POST_BY_CATEGORY_CODE_FAIL = 'staff/GET_ESTABLISHED_POST_BY_CATEGORY_CODE_FAIL'

export const SET_OPENED_CHILD_IDS = 'staff/SET_OPENED_CHILD_IDS'